export default __webpack_public_path__ + "static/char-s-40-ko-1afd805ba84009560393490278e21a48.webp";